import http from './httpService';
import {appModules} from '../utils/const';

export function getAllSubProcesses (processId, size, page = 0) {
  return http.get(`/subprocesses?processId.equals=${processId}&page=${page}&size=${size}&sort=id,asc&active.equals=true`);
}

export function getKeyRisk(id) {
  return http.get(`/key-indicators/${id}`);
}

export function updateKeyRisk(body) {
  return http.put('/key-indicators', body);
}

export function deleteKeyRisk(id) {
  return http.delete(`/key-indicators/${id}`);
}

export function addKeyRisk(body) {
  return http.post(`/key-indicators`, body);
}

export function deleteKeyRiskOccurrence(id) {
  return http.delete(`/key-indicator-occurs/${id}`);
}

export function addKeyRiskOccurrence(body) {
  return http.post(`/key-indicator-occurs`, body);
}

export function editKeyRiskOccurrence(body) {
  return http.put(`/key-indicator-occurs`, body);
}

export function getKeyRiskOccurrence(id) {
  return http.get(`/key-indicator-occurs/${id}`);
}

export function copyAllKeyIndicators() {
  return http.post('key-indicators/copy-all-key-indicators');
}
export function getRiskById (id) {
  return http.get(`risks/${id}?riskTypeId.equals=1&riskStatusId.in=1,2,3`);
}
export function getPotentialRisksList  (size, page= 0) {
  return http.get(`risks?riskTypeId.equals=1&riskStatusId.in=1,2,3&page=${page}&size=${size}`);
}
